import { AppInputOption } from '@helpers/input/input.option';

export const TypeOperations: AppInputOption[] = [
  { id: '001', description: 'Póliza Nueva' },
  { id: '005', description: 'Renovación' },
  { id: '007', description: 'Modificación' }
];
